import { faCoins, faFire, faPerson } from "@fortawesome/free-solid-svg-icons";

import type { AuthUser } from "../../../context/AuthProvider";
import CharacterImage from "../../../shared/components/user/CharacterImage";
import StatBar from "../../../shared/components/elements/StatBar";
import type { StatItem } from "../../../shared/components/elements/StatBar";

import AccountMenu from "./AccountMenu";

interface AccountSidebarProps {
    user: AuthUser;
    onEdit?: () => void; // Called when the user wants to change their character
}

const AccountSidebar = ({ user, onEdit }: AccountSidebarProps) => {
    const stats: StatItem[] = [
        { key: "credit", label: "اعتبار", value: user.credit, icon: faCoins },
        { key: "streak", label: "روزهای متوالی", value: user.streak, icon: faFire },
        { key: "xp", label: "امتیاز", value: user.xp, icon: faPerson }
    ];

    return (
        <aside className="w-full mt-10 lg:mt-0 lg:w-1/5">
            <div className="w-full border-2 border-gray-200 text-lg font-bold rounded-md bg-gray-100 p-10 flex justify-center items-center flex-col mb-5">
                <CharacterImage characterCode={user.character} editable={false} onEdit={onEdit} />

                <span className="text-lg block font-bold mt-5">{user.name}</span>
                <span className="text-md block font-bold mt-3 text-gray-700">
                    {user.phone_number}
                </span>
            </div>

            <StatBar items={stats} className="flex mb-5" />

            <AccountMenu />
        </aside>
    );
};

export default AccountSidebar;